import { render, staticRenderFns } from "./SummaryMultiple.vue?vue&type=template&id=84dac50c&scoped=true&"
import script from "./SummaryMultiple.vue?vue&type=script&lang=js&"
export * from "./SummaryMultiple.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMultiple.vue?vue&type=style&index=0&id=84dac50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dac50c",
  null
  
)

export default component.exports